/**
 * DrawingSnapIndicator - Visual indicator for snapping to drawing endpoints
 * Shows a green circle when a control point is near another drawing's endpoint
 */

import type { FieldCoordinateSystem } from '@/utils'
import type { Coordinate } from '@/types'

interface DrawingSnapIndicatorProps {
	/** Field coordinate system for pixel conversion */
	coordSystem: FieldCoordinateSystem
	/** The point to snap to */
	snapPoint: Coordinate
}

/**
 * Renders a green circle indicator at the snap target location
 * Used in control point overlays when dragging near drawing endpoints
 */
export function DrawingSnapIndicator({
										 coordSystem,
										 snapPoint,
									 }: DrawingSnapIndicatorProps) {
	const pixelPos = coordSystem.feetToPixels(snapPoint.x, snapPoint.y)

	return (
		<circle
			cx={pixelPos.x}
			cy={pixelPos.y}
			r={10}
			fill="none"
			stroke="var(--snap-drawing-stroke, #22c55e)"
			strokeWidth={3}
			pointerEvents="none"
		/>
	)
}
